module.exports = __webpack_public_path__ + "img/sichuan.44d2daae.jpg";